import React from 'react';
import styled from 'styled-components';

const TabsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  overflow-x: auto;
  padding-bottom: 4px;

  /* Hide scrollbar but allow scrolling */
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Tab = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: ${(props) =>
    props.active ? props.theme.colors?.primary || '#FA4616' : 'transparent'};
  border: ${(props) =>
    props.active
      ? `1px solid ${props.theme.colors?.primary || '#FA4616'}`
      : props.theme.name === 'dark'
      ? '1px solid rgba(255, 255, 255, 0.2)'
      : '1px solid rgba(0, 0, 0, 0.15)'};
  border-radius: 8px;
  color: ${(props) =>
    props.active
      ? '#ffffff'
      : props.theme.name === 'dark'
      ? props.theme.colors?.textGray?.secondary || '#94A3B8'
      : '#64748B'};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    border-color: ${(props) => props.theme.colors?.primary || '#FA4616'};
    color: ${(props) =>
      props.active ? '#ffffff' : props.theme.colors?.primary || '#FA4616'};
  }
`;

const TabIcon = styled.img`
  width: 18px;
  height: 18px;
  filter: ${(props) =>
    props.active
      ? 'brightness(0) saturate(100%) invert(100%)' // White
      : props.theme.name === 'dark'
      ? 'brightness(0) saturate(100%) invert(70%)' // Light gray
      : 'brightness(0) saturate(100%) invert(50%)'}; // Dark gray
`;

/**
 * POSCategoryTabs - Category tab navigation for POS
 *
 * @param {Object} props
 * @param {Array} props.categories - Array of category objects with id, name, icon
 * @param {string} props.activeCategory - Currently active category id
 * @param {Function} props.onSelect - Callback when a category is selected
 */
const POSCategoryTabs = ({ categories, activeCategory, onSelect }) => {
  if (!categories || categories.length === 0) return null;

  return (
    <TabsContainer>
      {categories.map((category) => (
        <Tab
          key={category.id}
          active={activeCategory === category.id}
          onClick={() => onSelect(category.id)}
        >
          {category.icon && (
            <TabIcon
              src={category.icon}
              alt={category.name}
              active={activeCategory === category.id}
            />
          )}
          {category.name}
        </Tab>
      ))}
    </TabsContainer>
  );
};

export default POSCategoryTabs;
